import React from 'react'
import PropTypes from "prop-types";
import {GameBestOfLegsComponent, GameFirstToLegsComponent} from "../../general/GameFirstToLegsComponent";
import {GameSetsComponent} from "../../general/GameSetsComponent";
import DHSwitch from "../../general/DHSwitch";

function TournamentCricketArea({
                                   showSets,
                                   showBestOfLegs,
                                   showPflichtfelder,
                                   sets,
                                   firstToLegs,
                                   bestOfLegs,
                                   zufallszahlen,
                                   zufallszahlenjedesleg,
                                   cutthroat,
                                   onSetsChanged,
                                   onFirstToLegsChanged,
                                   onBestOfLegsChanged,
                                   onZufallszahlenChanged,
                                   onZufallszahlenjedeslegChanged,
                                   onCutthroatChanged
                               }) {

    const cricketzufallszahlen = [
        {name: 'Ja', value: true},
        {name: 'Nein', value: false},
    ];
    const cricketcutthroat = [
        {name: 'Ja', value: true},
        {name: 'Nein', value: false},
    ];


    return <>
        {showSets &&
            <div className="grid">
                <div className="col-fixed" style={{width: "120px"}}>first to sets: {showPflichtfelder && "*"}</div>
                <div className="col-fixed" style={{width: "250px"}}>
                    <GameSetsComponent sets={sets}
                                       onChange={(sets) => onSetsChanged(sets)}/>
                </div>
            </div>
        }
        <div className="grid">
            <div className="col-fixed" style={{width: "120px"}}>first to
                legs: {bestOfLegs === undefined && showPflichtfelder && "*"}</div>
            <div className="col-fixed" style={{width: "250px"}}>
                <GameFirstToLegsComponent firstToLegs={firstToLegs}
                                          onChange={(firstToLegs) => {
                                              onFirstToLegsChanged(firstToLegs)
                                              {
                                                  firstToLegs !== undefined && onBestOfLegsChanged !== undefined && onBestOfLegsChanged(undefined)
                                              }
                                              ;
                                          }}/>
            </div>
        </div>
        {showBestOfLegs &&
            <div className="grid">
                <div className="col-fixed" style={{width: "120px"}}>best of
                    legs: {firstToLegs === undefined && showPflichtfelder && "*"}</div>
                <div className="col-fixed" style={{width: "250px"}}>
                    <GameBestOfLegsComponent bestOfLegs={bestOfLegs}
                                             onChange={(bestOfLegs) => {
                                                 onBestOfLegsChanged(bestOfLegs);
                                                 {
                                                     bestOfLegs !== undefined && onFirstToLegsChanged(undefined)
                                                 }
                                                 ;
                                             }}/>
                </div>
            </div>
        }
        <div style={{marginBottom: 10}}>
            <DHSwitch id="id-zufallszahl" label="Zufallszahlen" required={true} value={zufallszahlen} onChange={() => onZufallszahlenChanged(!zufallszahlen)}/>
        </div>
        {zufallszahlen && <>
            <div style={{marginBottom: 10}}>
                <DHSwitch id="id-zufallszahljedesleg" label="jedes Leg andere Zufallszahlen?" required={true} value={zufallszahlenjedesleg}
                          onChange={() => onZufallszahlenjedeslegChanged(!zufallszahlenjedesleg)}/>
            </div>
        </>
        }
        <div style={{marginBottom: 10}}>
            <DHSwitch id="id-cutthroat" label="Cutthroat" required={true} value={cutthroat}
                      onChange={() => onCutthroatChanged(!cutthroat)}/>
        </div>
    </>
}

TournamentCricketArea.propTypes = {
    sets: PropTypes.string,
    firstToLegs: PropTypes.string.isRequired,
    bestOfLegs: PropTypes.string,
    zufallszahlen: PropTypes.bool.isRequired,
    zufallszahlenjedesleg: PropTypes.bool.isRequired,
    cutthroat: PropTypes.bool.isRequired,
    onSetsChanged: PropTypes.func,
    onFirstToLegsChanged: PropTypes.func.isRequired,
    onBestOfLegsChanged: PropTypes.func,
    onZufallszahlenChanged: PropTypes.func.isRequired,
    onZufallszahlenjedeslegChanged: PropTypes.func.isRequired,
    onCutthroatChanged: PropTypes.func.isRequired,
    showSets: PropTypes.bool.isRequired,
    showBestOfLegs: PropTypes.bool.isRequired,
    showPflichtfelder: PropTypes.bool.isRequired,
};

export default TournamentCricketArea
